module.exports = __webpack_public_path__ + "static/media/TerrinaFechada.3a7cc827.png";